/* eslint-disable no-use-before-define */
import React from 'react'
import { arrayToggle } from '../../../twd'


export default ({selected, setSelected}) => {
    return <React.Fragment>
    {
        selected.length>0 && selected.map((a,i)=> (
            <button
                data-name="corporates-market-news-holding-search-tag"
                data-label={a.label}
                key={i}
                className="tag tag-dismissible"
                onClick={() => {
                    let n = arrayToggle(selected, a)
                    setSelected([...n])
                }}
            >{a.label}</button>
        ))
    }
    {
        selected.length === 0 && <div className="text-muted">
            <p>You have no active corporate bond holdings at this time.
            Within Holdings Search, existing positions are accessible within
            the Company dropdown - allowing for customized news searches
            aligned with your corporate holdings.</p>
            <br/>
            <p>For more information on corporate bond investing,
            please reference the Corporate Bond Resources module.</p>
        </div>
    }

    </React.Fragment>
}



// WEBPACK FOOTER //
// ./src/corporates/market-news/holding-search/tags.js